import type { AuthUser, UserRole } from "./types";

/** RBAC scaffold — replace with policy / resource checks when backend exposes permissions. */
export function hasAnyRole(user: AuthUser | null, roles: UserRole[]): boolean {
  if (!user?.role) {
    return false;
  }
  return roles.some((r) => r === user.role);
}

export function isAdmin(user: AuthUser | null): boolean {
  const r = user?.role;
  return r === "admin" || r === "super_admin";
}

export function isSuperAdmin(user: AuthUser | null): boolean {
  return user?.role === "super_admin";
}

/** Super admin, admin, or distributor — can open the Users management area. */
export function canManageTenantUsers(user: AuthUser | null): boolean {
  return hasAnyRole(user, ["super_admin", "admin", "distributor"]);
}

export function canManageDashboards(user: AuthUser | null): boolean {
  return canManageTenantUsers(user);
}
